<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>ico-N/ico-24-settings.gray</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g
      id="ico-N/ico-24-settings.gray"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M9.66078307,5.92221128 L10.0001513,3.61810777 C9.98755167,3.20603592 10.1590194,3 10.5145546,3 C11.0478573,3 13.7114632,3 14.1602031,3 C14.4593631,3 14.6058335,3.20603592 14.5996145,3.61810777 L14.9396616,5.90630331 C15.6071476,6.16694932 16.2262217,6.52428133 16.7796672,6.96108259 L18.9227361,6.11166301 C19.273301,5.89471551 19.5374672,5.94019298 19.7152348,6.24809544 C19.9818861,6.70994913 21.3136891,9.01669951 21.538059,9.40531969 C21.687639,9.66439982 21.5824419,9.89426492 21.2224677,10.094915 L19.4393072,11.5109091 C19.4950634,11.872083 19.5239914,12.2421133 19.5239914,12.6189 C19.5239914,12.9785737 19.4976315,13.3320906 19.4467381,13.6776244 L21.2245463,15.0856258 C21.5877108,15.2807501 21.6804093,15.5322635 21.5026417,15.840166 C21.2359904,16.3020196 19.9041874,18.60877 19.6798174,18.9973902 C19.5302375,19.2564703 19.2785699,19.2802995 18.9248147,19.0688777 L16.8257541,18.2400385 C16.2586955,18.6951222 15.6213072,19.0661721 14.9324812,19.3342961 L14.6037717,21.5660333 C14.6163713,21.9781051 14.4449036,22.184141 14.0893684,22.184141 C13.5560657,22.184141 10.8924598,22.184141 10.4437199,22.184141 C10.1445599,22.184141 9.99808947,21.9781051 10.0043085,21.5660333 L9.67044089,19.3194196 C8.99163629,19.0507376 8.36339848,18.6818893 7.80395689,18.231104 L5.6811869,19.072478 C5.33062202,19.2894255 5.0664558,19.243948 4.88868823,18.9360456 C4.62203688,18.4741919 3.29023393,16.1674415 3.06586396,15.7788213 C2.91628398,15.5197412 3.02148109,15.2898761 3.38145529,15.089226 L5.19045824,13.6527106 C5.14193867,13.3151036 5.11682988,12.969934 5.11682988,12.6189 C5.11682988,12.2516382 5.14431383,11.8907955 5.19733715,11.5383167 L3.37937668,10.0985153 C3.01621219,9.90339093 2.92351373,9.65187753 3.10128129,9.34397507 C3.36793265,8.88212138 4.6997356,6.575371 4.92410557,6.18675082 C5.07368555,5.92767069 5.32535312,5.90384151 5.67910828,6.11526328 L7.84784252,6.97161401 C8.39351194,6.53886894 9.00335742,6.18353606 9.66078307,5.92221128 Z M12.3204107,16.2838797 C14.3445231,16.2838797 15.9853904,14.6430124 15.9853904,12.6189 C15.9853904,10.5947876 14.3445231,8.95392033 12.3204107,8.95392033 C10.2962983,8.95392033 8.65543097,10.5947876 8.65543097,12.6189 C8.65543097,14.6430124 10.2962983,16.2838797 12.3204107,16.2838797 Z"
        id="settings"
        stroke="currentColor"
        stroke-width="2"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcoSettings',
};
</script>

<style lang="scss" scoped></style>
